import React, { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";

// Signed-in admins change their own password (current password required).
export default function ChangePasswordCard() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters");
    if (next !== confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await apiClient.post("/auth/password/change", { current_password: cur, new_password: next });
      setCur(""); setNext(""); setConfirm("");
      toast.success("Password updated. It will stay this way until you change it.");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  const field = (label, value, set, id, ac) => (
    <div>
      <label className="mono-label block mb-2">{label}</label>
      <input data-testid={id} type="password" value={value} onChange={(e) => set(e.target.value)} className="input-industrial" autoComplete={ac} required />
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="change-password-form" className="card-industrial corner-tick p-8 md:p-10 mt-8 space-y-5">
      <div className="flex items-center gap-3 mb-1">
        <Lock className="text-nex-gold" size={20} />
        <div className="mono-label">// CHANGE PASSWORD</div>
      </div>
      {field("Current password", cur, setCur, "change-password-current", "current-password")}
      {field("New password (8+ characters)", next, setNext, "change-password-new", "new-password")}
      {field("Confirm new password", confirm, setConfirm, "change-password-confirm", "new-password")}
      <button type="submit" disabled={busy} data-testid="change-password-submit" className="tick-btn-primary w-full justify-center disabled:opacity-50">
        {busy ? <><Loader2 size={16} className="animate-spin" /> Saving...</> : "Update password"}
      </button>
    </form>
  );
}
